import React from "react";
// eslint-disable-next-line no-unused-vars
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// ---- Images ----
import pallet1 from "../assets/images/pallets/euro.png";
// import pallet2 from "../assets/images/ab02.jpg";
// import pallet3 from "../assets/images/ab02.jpg";
// import pallet4 from "../assets/images/ab01.jpg";

import pallet5 from "../assets/images/pallets/stringer.png";
// import pallet6 from "../assets/images/ab02.jpg";
// import pallet7 from "../assets/images/ab02.jpg";
// import pallet8 from "../assets/images/ab01.jpg";

import pallet9 from "../assets/images/pallets/woodan.png";
// import pallet10 from "../assets/images/ab02.jpg";
// import pallet11 from "../assets/images/ab02.jpg";
// import pallet12 from "../assets/images/ab01.jpg";

import pallet13 from "../assets/images/pallets/skibidi.png";
// import pallet14 from "../assets/images/ab02.jpg";
// import pallet15 from "../assets/images/ab02.jpg";
// import pallet16 from "../assets/images/ab01.jpg";

import pallet17 from "../assets/images/pallets/plapall.jpg";
// import pallet18 from "../assets/images/ab02.jpg";
// import pallet19 from "../assets/images/ab02.jpg";
// import pallet20 from "../assets/images/ab01.jpg";

import pallet21 from "../assets/images/pallets/steel.png";
// import pallet22 from "../assets/images/ab02.jpg";
// import pallet23 from "../assets/images/ab02.jpg";
// import pallet24 from "../assets/images/ab01.jpg";

export default function Pallets() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.substring(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  // Transformed data to match the structure of Services1
  const productGroups = [
    {
      id: 1,
      image: pallet1,
      subtitle: "Euro Pallets",
      subtext:
        "Standard 1200x800 mm certified pallet used for European export with high load stability",
      btn: "Get In Touch",
      features: [
        {
          id: 1,
          icon: "/checkmark.svg",
          title: "Standard size 1200x800 mm",
        },
        {
          id: 2,
          icon: "/checkmark.svg",
          title: "Certified for European export",
        },
        {
          id: 3,
          icon: "/checkmark.svg",
          title: "High load stability",
        },
        {
          id: 4,
          icon: "/checkmark.svg",
          title: "Reusable and reliable",
        },
      ],
    },
    {
      id: 2,
      image: pallet5,
      subtitle: "Stringer Pallets",
      subtext:
        "Basic low-cost pallet with stringer support, used mainly for domestic transport",
      btn: "Get In Touch",
      features: [
        {
          id: 1,
          icon: "/checkmark.svg",
          title: "Basic pallet design",
        },
        {
          id: 2,
          icon: "/checkmark.svg",
          title: "Low cost solution",
        },
        {
          id: 3,
          icon: "/checkmark.svg",
          title: "2-way or 4-way entry",
        },
        {
          id: 4,
          icon: "/checkmark.svg",
          title: "Used for domestic transport",
        },
      ],
    },
    {
      id: 3,
      image: pallet9,
      subtitle: "Wooden Pallets",
      subtext:
        "Strong, cost-effective pallet with ISPM-15 treatment required for export and suitable for heavy loads",
      btn: "Get In Touch",
      features: [
        {
          id: 1,
          icon: "/checkmark.svg",
          title: "Strong and durable for heavy loads",
        },
        {
          id: 2,
          icon: "/checkmark.svg",
          title: "Cost-effective solution",
        },
        {
          id: 3,
          icon: "/checkmark.svg",
          title: "ISPM-15 required for export",
        },
        {
          id: 4,
          icon: "/checkmark.svg",
          title: "Used in domestic and export logistics",
        },
      ],
    },
    {
      id: 4,
      image: pallet13,
      subtitle: "Wooden Skids",
      subtext:
        "Simple base support without bottom deck, ideal for heavy machinery handling and transport",
      btn: "Get In Touch",
      features: [
        {
          id: 1,
          icon: "/checkmark.svg",
          title: "Base support without bottom deck",
        },
        {
          id: 2,
          icon: "/checkmark.svg",
          title: "Ideal for heavy machinery",
        },
        {
          id: 3,
          icon: "/checkmark.svg",
          title: "Easy forklift handling ",
        },
        {
          id: 4,
          icon: "/checkmark.svg",
          title: "Cost-effective option",
        },
      ],
    },
    {
      id: 5,
      image: pallet17,
      subtitle: "Plastic Pallets",
      subtext:
        "Lightweight, reusable, hygienic pallet with no fumigation required, ideal for pharma and food industries",
      btn: "Get In Touch",
      features: [
        {
          id: 1,
          icon: "/checkmark.svg",
          title: "Lightweight and reusable",
        },
        {
          id: 2,
          icon: "/checkmark.svg",
          title: "Hygienic and clean",
        },
        {
          id: 3,
          icon: "/checkmark.svg",
          title: "No fumigation required",
        },
        {
          id: 4,
          icon: "/checkmark.svg",
          title: "Ideal for pharma and food",
        },
      ],
    },
    {
      id: 6,
      image: pallet21,
      subtitle: "Metal Pallets",
      subtext:
        "Basic low-cost pallet with stringer support, used mainly for domestic transport",
      btn: "Get In Touch",
      features: [
        {
          id: 1,
          icon: "/checkmark.svg",
          title: "Very high load capacity",
        },
        { id: 2, icon: "/checkmark.svg", title: "Strong metal structure" },
        {
          id: 3,
          icon: "/checkmark.svg",
          title: "Used for heavy machinery ",
        },
        {
          id: 4,
          icon: "/checkmark.svg",
          title: " Long-lasting durability",
        },
      ],
    },
  ];

  return (
    <section className="bg-white py-16" id="products">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="grid grid-cols-1 pb-8 text-center">
          <h6 className="text-[#69A41D] text-[40px] font-medium uppercase mb-2 mt-24">
            Our Pallets
          </h6>
          <p className="text-slate-400 dark:text-slate-300 max-w-xl mx-auto mt-3 text-[18px]">
            We offer a range of high-quality products designed to meet your
            packaging needs with precision and reliability.
          </p>
        </div>

        {/* Products */}
        {productGroups.map((item) => (
          <div
            key={item.id}
            id={item.subtitle.toLowerCase().replace(/\s/g, "")}
            className="grid lg:grid-cols-2 gap-12 items-center mb-20"
          >
            {/* LEFT - IMAGE */}
            <div className="flex justify-center">
              <img
                src={item.image}
                alt={item.subtitle}
                className="w-full max-w-md object-contain rounded-xl shadow-md bg-gray-50 p-6"
              />
            </div>

            {/* RIGHT - DETAILS */}
            <div>
              {/* Title */}
              <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                {item.subtitle}
              </h3>

              {/* Description */}
              <p className="text-gray-500 mb-5">{item.subtext}</p>

              {/* Features */}
              <ul className="mb-6">
                {item.features?.map((i) => (
                  <li
                    key={i.id}
                    className="flex items-center text-gray-600 mb-2"
                  >
                    <img src={i.icon} className="w-4 h-4 mr-3" alt="icon" />
                    {i.title}
                  </li>
                ))}
              </ul>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mt-6">
                {/* Contact Us */}
                <a
                  href="https://wa.me/918830552784"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#18443A] hover:bg-[#0f2f29] text-white px-6 py-2 rounded-md font-semibold text-center"
                >
                  Contact Us
                </a>

                {/* Download PDF */}
                <a
                  href="/pdf/pallet-catalog.pdf"
                  download
                  className="border border-[#18443A] text-[#18443A] hover:bg-[#18443A] hover:text-white px-6 py-2 rounded-md font-semibold text-center"
                >
                  Download PDF
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
  
}
